import { z } from 'zod';

export const documentSchema = z.object({
  idDocument: z.number(),
  Data: z.string().optional(),
  FileName: z.string(),
  idMIMEType: z.number(),
  Created_at: z.string(),
  idDocumentDirectory: z.number().nullable(),
  idLegalTransaction: z.number().nullable(),
  perEmail: z.coerce.boolean().default(false).nullable(),
  isFromTemplate: z.coerce.boolean().default(false).nullable(),
});

export type IDocument = z.infer<typeof documentSchema>;

const toNullableBoolean = (value: unknown): boolean | null =>
  value === null || value === undefined ? null : Boolean(value);

/**
 * Raeumt ein direkt von `/document/{id}` geladenes Dokument auf.
 *
 * Die API liefert `perEmail`/`isFromTemplate` als TINYINT (0/1). Die
 * Swagger-Definition `documentDef` erlaubt dort aber nur `boolean` oder `null` —
 * ein ungeprueft weitergegebenes `0` fuehrt zu einem 400 („0 is not of type
 * 'boolean', 'null'"), sobald das Dokument wieder an das Backend geht.
 */
export const normalizeDocument = (documentObject: IDocument): IDocument => ({
  ...documentObject,
  Created_at: documentObject.Created_at ?? '',
  perEmail: toNullableBoolean(documentObject.perEmail),
  isFromTemplate: toNullableBoolean(documentObject.isFromTemplate),
});
